export const GET_ALL_PROVISIONING_POLICIES = 'GET_ALL_PROVISIONING_POLICIES';
export const GET_PROVISIONING_POLICIES_DTO = 'GET_PROVISIONING_POLICIES_DTO';
export const PROVISIONING_POLICIES_COUNT = 'PROVISIONING_POLICIES_COUNT';